<template>
  <div v-loading="loading" element-loading-text="加载中">
    <el-row>
      <el-col :span="24">
        <div class="element-select">
          <el-select v-model="value" @change="adminModulePointPie" placeholder="请选择">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div id="charts-box-copy-lpie"></div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import echarts from "echarts";
import { API_control } from "../../../api/index.js";
export default {
  data() {
    return {
      chartsXAxis: [],
      //折线图数据
      chartsData: [],
      value: "1",
      loading: false,
      options: [
        {
          value: "1",
          label: "最近一个月",
        },
        {
          value: "3",
          label: "最近三个月",
        },
        {
          value: "6",
          label: "最近半年",
        },
        {
          value: "12",
          label: "最近一年",
        },
      ],
      chartPie: [],
      legend: [],
      token: "",
      checkCode: "",
      colorList: [
        "#FF6383",
        "#FF9F40",
        "#FFCB48",
        "#5C89FF",
        "#7C6AF2",
        "#C95FF2",
        "#52c41a",
        "#13c2c2",
        "#c41d7f",
      ],
    };
  },
  created() { },

  mounted() {
    this.getCookie();
    this.getData();
  },

  methods: {
    //读取cookie
    getCookie: function () {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split("; ");
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split("=");
          if (arr2[0] == "dnnyptadmin_token") {
            this.token = arr2[1];
          } else if (arr2[0] == "dnnyptadmin_checkCode") {
            this.checkCode = arr2[1];
          }
        }
      }
    },

    getData() {
      this.adminModulePointPie();
    },

    adminModulePointPie(val) {
      var param = {
        count: this.value,
        token: this.token,
        checkCode: this.checkCode,
      };
      this.loading = true;
      API_control.adminModulePointPie(param).then((res) => {
        if (res.data.code == 200) {
          var list = [];
          var data = res.data.data;
          var legend = [];
          for (var p in data) {
            list.push({ name: data[p].modulename, value: data[p].sumpoint });
            legend.push(data[p].modulename);
          }
          // 设置label为对应的颜色
          list.map((item, index) => {
            item.label = {
              formatter: function (params) {
                return (
                  "{nm|" +
                  params.data.name +
                  "}" +
                  "\n\n{zz|" +
                  params.data.value +
                  "}"
                );
              },
              rich: {
                zz: {
                  align: "right",
                  fontSize: 16,
                  backgroundColor: "white",
                  color: this.colorList[index],
                  fontWeight: "700",
                },
                nm: {
                  color: "#666666",
                  fontSize: 14,
                  backgroundColor: "white",
                  fontWeight: "400",
                },
              },

            }
            return item;
          })
          this.chartPie = list;
          this.legend = legend;
          this.initCharts();
          this.loading = false;
        }
      });
    },

    initCharts() {
      var charts = null;
      charts = echarts.init(document.getElementById("charts-box-copy-lpie"));
      charts.showLoading(); //显示等待框
      charts.setOption({
        title: {
          text: "模块使用情况",
          top: "top",
          left: "left",
          textStyle: {
            color: "#666666",
            fontSize: 16,
            fontWeight: 500,
          },
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)",
        },

        series: [
          {
            name: "模块使用情况",
            type: "pie",
            avoidLabelOverlap: true,
            // minAngle: 25,
            // startAngle: 270,
            radius: "35%",
            center: ["50%", "70%"],
            data: this.chartPie,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
            label: {
              show: true,
              alignTo: "edge",
              margin: 5,
              lineHeight: 10, // 行高
            },
          },
        ],
        color: [
          "#FF6383",
          "#FF9F40",
          "#FFCB48",
          "#5C89FF",
          "#7C6AF2",
          "#C95FF2",
          "#52c41a",
          "#13c2c2",
          "#c41d7f",
        ],
      });
      charts.hideLoading(); //隐藏等待框
      //this.loading = false;
    },
  },
};
</script>

<style scoped lang="scss">
#charts-box-copy-lpie {
  width: 100%;
  height: 450px;
  background-color: white;
  border-radius: 2px;
}

.element-select {
  float: right;
  position: relative;
  z-index: 888;
}
</style>



// WEBPACK FOOTER //
// rightCharts.vue?0bc75250